import React from 'react'

export default ()=>{
    return(
        <style js="true">{`

        .sect5 h1 {
            color: #fefefe;
            font-size: 44px;
        }
        .panel-accordion {
            background: none;
            padding: 0 18px;
            display: none;
            overflow: hidden;
            color: #e7e7e2;
            font-size: 19px;
            line-height: 33px;
        }
        .button-header-text4 {
            padding-left: 16px;
            margin-top: -3px;
            color: white;
            font-size: 18px;
        }
        .button-text-header4 {
            font-size: 28px;
            margin-top: -1px;
            color: white;
            text-align:center;
        }
        button#clip-div4 {
            background-image: linear-gradient(#e07900, #fdb05b);
            border-radius: 36px;
            border: #e07900!important;
            height: 60px!important;
            margin-top: 2px!important;
            margin-left: 2px;
            width: 358px!important;
            padding-top: 7px;
        }


        .img{
            height:30px;
        }

        .CollapsibleComponent {
            width: 1007px;
            padding-top: 4%;
        }
        button.accordion-head.additionalClassForHead {
         
        }
        .accordion-head {
            background-color:#f37f00;
        }
        .center {
            display: flex;
            align-items:center;
            justify-content: space-around;
            padding-top: 2%;
        }
       
        .button-text1{
            padding-left:2%;
        }
        .collapse-first {
            display: flex;
            flex-direction: column;
        }
        .debt-inside-span {
            font-size: 18px;
        }
        .collapse-image-heading-row{
            display: flex;
            justify-content: space-between;
        }
        .h6{
            font-size: 23px;

        }
      
      `}
        </style>
    );
}